import axios from 'axios'

let orderAuditBase = window._env_.VUE_APP_ORDER_AUDIT_API_HOST

export function queryAuditTask (params, config) {
  return axios.post(`${orderAuditBase}/admin/audit_task/query`, params, config)
}

export function createAuditTask (params, config) {
  return axios.post(`${orderAuditBase}/admin/audit_task/create`, params, config)
}

export function unlockAuditTask (params, config) {
  return axios.post(`${orderAuditBase}/admin/audit_task/unlock_${params.id}`, {}, config)
}




// WEBPACK FOOTER //
// ./src/views/audit-task/audit-task.api.js